<template>
  <dropdown
    ref="dropdown"
    :width="width"
    :placement="placement"
    :transition="transition"
    :visible-arrow="visibleArrow"
    :trigger="trigger"
    :margin-top="marginTop"
    :disabled="disabled"
    :popoverClass="computedClass"
    @show="$emit('show')"
    class="dropdown-menu"
  >
    <template v-slot:reference>
      <slot>
        <base-button>哈哈</base-button>
      </slot>
    </template>
    <template>
      <div
        class="dropdown-menu__content"
        :style="from === 'navbar' ? 'font-size:20px' : ''"
        v-ps
        v-loading="loading"
      >
        <div v-if="!menuList || menuList.length == 0" class="is-empty">
          无数据
        </div>
        <template v-else>
          <div
            v-for="(menu, index) in menuList"
            :key="index"
            @click="handleClick(menu)"
            :class="from"
          >
            <slot name="menuItem" :menu="menu">
              <el-tooltip
                v-if="from === 'detailDialog' && menu.hasOwnProperty('desc')"
                class="item"
                effect="dark"
                placement="left"
                :disabled="_.isEmpty(menu.desc)"
                :content="menu.desc"
              >
                <menu-item
                  from="button"
                  :key="index"
                  :title="menu.title"
                  :icon="menu.icon"
                  :color="menu.iconColor"
                  style="display: inline-block;"
                ></menu-item>
              </el-tooltip>
              <menu-item
                v-else
                :from="from === 'detailDialog' ? 'button' : from"
                :key="index"
                :title="menu.title"
                :desc="menu.desc"
                :icon="menu.icon"
                :color="menu.iconColor"
                :style="
                  ['主题换肤', '退出登录'].includes(menu.title)
                    ? 'border-top:1px solid #EAECF0'
                    : ''
                "
                style="display: inline-block;"
              ></menu-item>
            </slot>
          </div>
        </template>
      </div>
    </template>
  </dropdown>
</template>

<script>
import Dropdown from "@/components/UIComponents/Dropdown"
import BaseButton from "@/components/UIComponents/Button"
import MenuItem from "./MenuItem"
export default {
  name: "dropdown-menu",
  components: {
    BaseButton,
    Dropdown,
    MenuItem
  },
  props: {
    marginTop: {
      type: [Number, String],
      default: "14"
    },
    menuList: {
      type: Array,
      default: () => []
    },
    width: String,
    placement: String,
    transition: String,
    visibleArrow: Boolean,
    trigger: String,
    disabled: Boolean,
    loading: Boolean,
    popoverClass: String,
    from: String
  },
  computed: {
    computedClass() {
      if (!this.popoverClass) return "dropdown-menu-popover"
      return `dropdown-menu-popover ${this.popoverClass}`
    }
  },
  methods: {
    open() {
      this.$refs.dropdown.open()
    },
    close() {
      this.$refs.dropdown.close()
    },
    handleClick(menu) {
      this.close()
      this.$emit("click", menu.command, menu)
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown-menu-popover {
  .is-empty {
    @include flex-center;
    height: 40px;
    color: $color-font-second;
  }
  .dropdown-menu__content {
    position: relative;
    max-height: 70vh;
  }
}
.navbar {
  padding: 0 8px;
}
</style>
